export const LABEL = 'You have not added a question for this form. Click the button below to add a question.';
